export default {
    BASE_URL: 'https://shop-dev.agrigatehub.com/api',
    WALLET_URL: 'https://wallet-dev.agrigatehub.com/api',

    // BASE_URL: 'http://migrate-beeshop.beeapps.systems/api',
    //  WALLET_URL: 'http://migrate-beewallet.beeapps.systems/api',

    LOCALE: 'km',

    FIREBASE_API_KEY: 'AIzaSyCchzBjUFMzRi1k76j5KAQXjB17YKf4OIY',
    FIREBASE_AUTHDO_MAIN: 'AIzaSyCchzBjUFMzRi1k76j5KAQXjB17YKf4OIY',
    FIREBASE_STORAGE_BUCKET: 'bee-shop-b9f1b.appspot.com',
    FIREBASE_MESSAGING_SENDER_ID: '633046026428'
}
// BASE_URL: 'http://migrate-beeshop.beeapps.systems/api',
// WALLET_URL: 'http://migrate-beewallet.beeapps.systems/api',
//const baseURL = "http://beeshop-mcril-dev.beeapps.systems/api";
//const baseURL = "http://training-beeshop.beeapps.systems/api";
//const walletURL = "http://training-beewallet.beeapps.systems/api";
//const walletURL = "http://beewallet-sit.beeapps.systems/api";
//const walletURL = "http://beewallet-dev.beeapps.systems/api";
